import React, { Component } from "react";
import { withUsers } from "../../../shared/containers/containerUsers";
import Icon from "../../../shared/items/static/icon";
import Input from "../../../shared/items/contols/input";
import styles from "./cmsUsers.module.scss";
import CmsUsersTable from "./CmsUsersTable";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";
import { Checkbox } from "@mui/material";

let timeOutId = null;

class CmsUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: null,
      blockUsersView: false,
    };
  }

  componentDidMount() {
    const { onGetUsers, companyId = null } = this.props;

    onGetUsers({ companyId });
  }

  onChangeSearchTerm(name, searchTerm) {
    this.setState({ searchTerm });

    clearTimeout(timeOutId);
    const getUsers = () => {
      const { searchTerm } = this.state;
      const { onGetUsers, companyId = null } = this.props;

      onGetUsers({ searchTerm, companyId });
    };

    timeOutId = setTimeout(getUsers, 400);
  }

  render() {
    const { usersDataState } = this.props;
    const { blockUsersView } = this.state;

    return (
      <div className={styles.cmsUsersMainContainer}>
        <div className={styles.searchContainer}>
          <div className={styles.searchUsers}>
            <Input name="searchTerm" type="text" handleChangeStore={this.onChangeSearchTerm.bind(this)} placeholder="Поиск" />
            <div className={styles.container_searchBtn}>
              <Icon name="search" />
            </div>
          </div>
          <div style={{ padding: "5px 5px 0px" }}>
            <Checkbox
              checked={blockUsersView}
              onChange={() => {
                this.setState({ blockUsersView: !blockUsersView });
              }}
              style={{
                padding: "0px",
                transform: "scale(1)",
              }}
            />
            <span>Показать заблокированых пользователей</span>
          </div>

          {usersDataState === states.REQUEST ? (
            <div style={{ display: "flex", justifyContent: "center", paddingLeft: 10 }}>
              <Preloader size={30} />
            </div>
          ) : null}
        </div>
        <CmsUsersTable blockUsersView={blockUsersView} />
      </div>
    );
  }
}

export default withUsers(CmsUsers);
